// Must match the entry main.js inits, or track() hits a separate instance
import mixpanel from 'mixpanel-browser/src/loaders/loader-module-core'
import { duplicateSetGroupingOptions } from '@/constants'

export function track(eventLabel, options = {}) {
  try {
    mixpanel.track(eventLabel, {
      system_id: window.location.host,
      ...options,
    })
  } catch (error) {
    console.log(error)
  }
}

export function trackDeleteRule(type, directorRuleName) {
  track(`Delete ${type} Rule`, {
    directorRuleName,
  })
}

export function trackAdvancedFilters(gridLabel, advancedFilters = []) {
  const appliedFilters = (advancedFilters || []).filter(
    filter => filter.field && filter.operator,
  )

  if (appliedFilters.length === 0) {
    return
  }

  track(`Advanced Filters - ${gridLabel}`, {
    numberOfFilters: appliedFilters.length,
  })
}

export function trackOnOffRuleProperty(
  ruleType,
  property,
  oldValue,
  newVale,
  directorRuleName,
) {
  let change = undefined

  if (oldValue && !newVale) {
    change = 'Off'
  } else if (!oldValue && newVale) {
    change = 'On'
  }

  if (change) {
    track(`${ruleType} Rule - ${property} - ${change}`, {
      directorRuleName,
    })
  }
}

// A rule that has never been saved has no previous selection to report.
const NO_PREVIOUS_SELECTION = '-'

const getDuplicateSetGroupingLabel = value =>
  duplicateSetGroupingOptions.find(option => option.value === value)?.label ??
  NO_PREVIOUS_SELECTION

export function trackDuplicateSetGrouping(oldValue, newValue, options = {}) {
  if (oldValue === newValue) return

  track('Duplicate set grouping', {
    old: getDuplicateSetGroupingLabel(oldValue),
    new: getDuplicateSetGroupingLabel(newValue),
    ...options,
  })
}

export function trackMatchSingleObjectDuplicates(
  oldValue,
  newValue,
  options = {},
) {
  if (!!oldValue === !!newValue) return

  track(`Match Single Object Duplicates - ${newValue ? 'On' : 'Off'}`, options)
}

export default {
  track,
}
